import * as React from "react";
import { Numeric, bisector, min, max } from "d3-array";
import { interpolate } from "d3-interpolate";
import { assertValue } from "../app/utils/assert";

type Domain = number | Numeric;
type Point = { x: number, y: number };

// https://github.com/d3/d3-zoom/blob/master/src/zoom.js#L33
export const defaultWheelDelta = (e: React.WheelEvent<SVGElement>): number => e.deltaY * (e.deltaMode ? 120 : 1) / 500;

export const getPoint = (e: React.MouseEvent<any>, element: SVGGraphicsElement): Point => 
{
    assertValue(element);
    const toSVGCoordinateSystem = element.getScreenCTM().inverse();
    return mult(toSVGCoordinateSystem, { x: e.clientX, y: e.clientY });
}

export const getClip = <T>(data: T[], x: (datum: T) => Domain, range: [Domain, Domain], interpolateAt: (left: T, right: T, at: Domain) => T): T[] => {
    const bisect = bisector<T, Domain>(d => x(d));
    const l = bisect.left(data, range[0]);
    const h = bisect.right(data, range[1]);

    const result = data.slice(l, h);
    if(l > 0 && l < data.length)
        result.splice(0, 0, interpolateAt(data[l-1], data[l], range[0]));
    if(h > 0 && h < data.length)
        result.push(interpolateAt(data[h-1], data[h], range[1]));
    
    return result;
}

export const mult = (transform: SVGMatrix, p: Point): Point => {
    return {
        x: transform.a*p.x + transform.c*p.y + transform.e,
        y: transform.b*p.x + transform.d*p.y + transform.f 
    };
}

export const scaleSelection = <D extends Numeric>(dataExtent: [D, D], selection: [D, D], pivot: D, delta: number): [D, D] => {
    const iLow = interpolate(pivot, selection[0]);
    const iHight = interpolate(pivot, selection[1]);
    const k = Math.pow(2, delta);
    
    return [
        max([dataExtent[0], iLow(k)]) as D,
        min([dataExtent[1], iHight(k)]) as D
    ];
}


// WEBPACK FOOTER //
// ./src/d3chart/zoom.ts